import React from 'react'
import * as TerminateProjectType from './terminateProjectType'

import { RoutePath } from '../../../../../../router/routesConfig'
import useLookupService from '../../../../../../services/lookup/useLookupService'
import { generatePath, useHistory } from 'react-router-dom'

import useWebService from '../../../../../../services/web/useWebService'
import { DialogType } from '../../../../../../control/dialog/dialog'
import useLoading from '../../../../../../control/loading/useLoading'
import { topicForLecturer, topicForStudent } from '../../../../../../constants/constants'
import constSubmittedType from '../../../../../../constants/submittedType'

import useAuthenStore from '../../../../../../stores/authen/authenStore'
import useAppFolderAndTabAction from '../../../../../../stores/appFolderAndTab/appFolderAndTabAction'
import * as REQServiceTypes from '../../../../../../services/web/types/requestWebServiceTypes'
import _ from 'lodash'
import useManageProjectStore from '../../../../../../stores/manageProject/useManageProjectStore'
import useManageProjectAction from '../../../../../../stores/manageProject/useManageProjectAction'
import { encryptionAES } from '../../../../../../utilities/encryption'
import useTranslate from '../../../../../../i18n/useTranslate'
import { ResultDocumentTopicLut } from '../../../../../../services/lookup/types/responseLookupServiceTypes'
import useProjectHook from '../../../../shareLogic/useProjectHook'
import useCheckPermission from '../../../../../../utilities/checkPermission'
import {
    withFileTokenInfo,
    trimEmplyFileInfo,
    checkAllAdditionalDocTopicsHavePdf,
} from '../../../../../../utilities/additionalDoc'

type UploadFileObjType = {
    uploadFileObj: {
        documentTopicID: number

        fileList: {
            documentTopicID: number
            fileID: string
            fileToken: string
            filename: string
            path: string
        }[]

        subTopicPageList?: {
            page: string
            documentTopicID: number
            subtopicID: number
        }[]
    }
}

type MyFileDataType = {
    documentTopicID?: number
    fileTokenInfo: Array<{
        replaceFileID: number
        fileToken: string
        fileExtension?: string
        fileID: any
    }>
    subtopic?: {
        subtopicID: number
        page: number | string
    }[]
}

const useRequestForm = (props: TerminateProjectType.UseRequestFormType) => {
    const { formMode, projectSubmittedTypeID, isViewMode, onSaveComplete, initialData } = props

    const translate = useTranslate()
    const authenStore = useAuthenStore()
    const projectHook = useProjectHook()

    const manageProjectStore = useManageProjectStore()
    const manageProjectAction = useManageProjectAction()
    const checkPermission = useCheckPermission()

    const { profile } = authenStore

    const { configLoading, loadingClose, loadingOpen } = useLoading()
    const callWebService = useWebService()
    const history = useHistory()
    const callLookup = useLookupService()
    const [selectedIrb, setSelectedIrb] = React.useState<string | undefined>('1')

    const dialogTwoRef = React.useRef<Record<string, Function>>()
    const projectIDRef = React.useRef<number>()
    const submittedIDRef = React.useRef<number>()
    const irbRef = React.useRef<number>()
    const parameterForSaveRef = React.useRef<any>()
    const submitValueRef = React.useRef<any>()
    const isDraftRef = React.useRef<boolean>(false)
    const [configDialog, setConfigDialog] =
        React.useState<Pick<DialogType, 'title' | 'content' | 'type' | 'onClickConfirm' | 'onAfterClose'>>()
    const appFolderAndTabAction = useAppFolderAndTabAction()
    const { documentTopic } = manageProjectStore
    const researcherTypeRef = React.useRef<string>()
    const documentTopicRef = React.useRef<ResultDocumentTopicLut[]>()
    const valuesForm = React.useRef<TerminateProjectType.MyRequestFormType>()
    const tabSelectedIndexRef = React.useRef<number | null>(null)
    const newTabSelectedRef = React.useRef<any>(null)
    const [initialUploadFile, setInitialUploadFile] = React.useState<any>()

    React.useEffect(() => {
        return () => {
            //clear ค่า tabRef
            tabSelectedIndexRef.current = null
            newTabSelectedRef.current = null
        }
    }, [])
    React.useEffect(() => {
        if (manageProjectStore.projectData?.irb && manageProjectStore.projectData?.submitTypeInfo.value) {
            getDocumentTopicLut(
                manageProjectStore.projectData?.irb,
                manageProjectStore.projectData?.submitTypeInfo.value,
            )
        }
    }, [manageProjectStore.projectData?.submittedID])

    React.useEffect(() => {
        createInitialUploadFile()
    }, [
        manageProjectStore.documentTopic,
        JSON.stringify(manageProjectStore.projectData?.documentInfo),
        JSON.stringify(manageProjectStore.projectData?.latestDocument),
    ])

    const getDocumentInfo = (val: any) => {
        let fileDataList = val.uploadFile.filter((itm: any) => itm.uploadFileObj.fileList.length > 0)
        let myFileData: Array<REQServiceTypes.DocumentInfo> = []

        fileDataList.forEach((uploadObj: UploadFileObjType) => {
            const subTopicLst = uploadObj?.uploadFileObj.subTopicPageList?.map((subtopic) => {
                return {
                    subtopicID: subtopic.subtopicID,
                    page: subtopic.page,
                }
            })

            // const fileTokenInfo: Array<string> = uploadObj.uploadFileObj.fileList?.map((file) => file.fileToken) ?? []
            const fileTokenInfo: Array<{
                replaceFileID: number
                fileToken: string
                fileExtension?: string
                fileID: any
            }> =
                uploadObj.uploadFileObj.fileList?.map((file) => {
                    return {
                        //@ts-ignore
                        replaceFileID: file?.replaceFileID ? file.replaceFileID : null,
                        fileToken: file.fileToken,
                        fileExtension: file.filename.split('.').pop(),
                        fileID: file?.fileID ? file.fileID : null,
                    }
                }) ?? []

            myFileData.push({
                documentTopicID: uploadObj?.uploadFileObj?.documentTopicID,
                fileTokenInfo: fileTokenInfo,
                subtopic: subTopicLst && subTopicLst.length > 0 ? subTopicLst : [],
            })
        })

        return myFileData
    }
    const getParameterForSave = (value: TerminateProjectType.MyRequestFormType) => {
        let submittedTypeID = projectSubmittedTypeID
        if (manageProjectStore && manageProjectStore?.projectData) {
            if (manageProjectStore.projectData.submitTypeInfo && manageProjectStore.projectData.submitTypeInfo?.value) {
                submittedTypeID = manageProjectStore.projectData.submitTypeInfo?.value
            }
        }

        const documentAdditionalInfo = withFileTokenInfo(trimEmplyFileInfo(value.documentAdditionalInfo))

        const parameterForSave: REQServiceTypes.CreateProjectRequestType = {
            projectID: manageProjectStore?.projectData?.projectID ?? null,
            submittedID: manageProjectStore?.projectData?.submittedID ?? null,
            irb: value.IRB ? parseInt(value.IRB.value) : null, //parseInt(value?.faculty?.irb) || null
            userID: profile.userId as number,
            projectName_th: value?.projectNameTH || null,
            projectName_en: value?.projectNameEN || null,
            researchProjectSummary_th: value?.researchProjectSummaryTH || null,
            researchProjectSummary_en: value?.researchProjectSummaryEN || null,
            projectSubmitTypeID: submittedTypeID, //1, // hard code ประเภทการยื่น เป็น 1 (โครงการใหม่)

            facultyID: value.faculty ? parseInt(value.faculty.value) : null,
            requestPhase: value.numPhase ? value.numPhase : null,
            isTools: value.isPhase === '2' ? (value.isTools === '2' ? true : false) : null,
            researcherTypeID: value.researcherType ? parseInt(value.researcherType.value) : null,
            titleNameID: value.titleName ? parseInt(value.titleName) : null,
            titleNameOther_th: value.otherTitleNameTH ? value.otherTitleNameTH : null,
            titleNameOther_en: value.otherTitleNameEN ? value.otherTitleNameEN : null,
            academicPositionID: value.academicPosition ? parseInt(value.academicPosition) : null,
            academicPositionOther_th: value.otherAcademicPositionTH ? value.otherAcademicPositionTH : null,
            academicPositionOther_en: value.otherAcademicPositionEN ? value.otherAcademicPositionEN : null,
            educationLevelID: value.educationLevel ? parseInt(value.educationLevel.value) : null,
            researcherName_th: value.nameTH ? value.nameTH : null,
            researcherName_en: value.nameEN ? value.nameEN : null,
            email: value.email ? value.email : null,
            homePhone: value.homePhone ? value.homePhone : null,
            mobilePhone: value.mobilePhone ? value.mobilePhone : null,
            fax: value.fax ? value.fax : null,
            isDraft: value?.submitType === 'save' ? false : true,
            documentInfo: getDocumentInfo(value),
            documentAdditionalInfo,
            isLanguage_th: value.langTH ? value.langTH : false,
            isLanguage_en: value.langEN ? value.langEN : false,
            isRequestCertificatePaper: value.isCertificatePaperList === '1' ? true : false,
            projectAdvisor: value?.projectAdvisor ?? null,
            projectAdvisorEmail: value?.projectAdvisorEmail ?? null,
            projectAdvisorEmailReserve: value?.projectAdvisorEmailReserve ?? null,
            isDr: value.isDr ? value.isDr : false,
        }

        return parameterForSave
    }
    const handleClickSubmit = (value: TerminateProjectType.MyRequestFormType) => {
        submitValueRef.current = value
        const parameterForSave: REQServiceTypes.CreateProjectRequestType = getParameterForSave(value)
        parameterForSaveRef.current = parameterForSave
        switch (value.submitType) {
            case 'save':
                // code block
                isDraftRef.current = false
                handleSave()

                break

            case 'draft':
                // code block
                isDraftRef.current = true
                handleSaveDraft()

                break
            default:
                break
        }
    }
    const checkRequirePDF = (documentInfo: MyFileDataType[]) => {
        let isRequirePDF = false

        for (let i = 0; i < documentInfo?.length; i++) {
            if (!isRequirePDF) {
                for (let j = 0; j < documentInfo[i]?.fileTokenInfo.length; j++) {
                    if (documentInfo[i]?.fileTokenInfo[j].fileExtension === 'pdf') {
                        isRequirePDF = false
                        break
                    } else {
                        isRequirePDF = true
                    }
                }
            }
        }
        return isRequirePDF
    }

    const checkSubtopic = (documentInfo: MyFileDataType[]) => {
        let isEmptyPage = false

        //หาว่าหัวข้ออัปโหลดเอกสารมีให้อัปโหลดหัวข้อย่อยมั้ย
        const docTopic = manageProjectStore.documentTopic?.filter((item) => item.subtopic.length > 0)

        //ถ้ามีให้เข้าไปเช็คตามเงื่อนไข if
        if (docTopic?.length) {
            // วน loop หัวข้อที่มีให้อัปโหลดเอกสารหัวข้อย่อย
            docTopic.forEach((mainTopic) => {
                // วน loop หัวข้อที่มีการอัปโหลดเอกสารเข้ามา
                documentInfo.forEach((itm) => {
                    // เช็คว่าเอกสารที่มีการอัปโหลดเข้ามาใช่เอกสารที่มีหัวข้อย่อยให้อัปโหลดหรือป่าว
                    if (mainTopic.id === itm.documentTopicID) {
                        // เช็คว่าหัวข้อย่อยที่อัพโหลดเข้ามาครบมั้ย
                        if (itm.subtopic?.length != mainTopic.subtopic.length) {
                            isEmptyPage = true
                        } else {
                            // เช็คว่าที่อัปมาครบมีช่องไหนกรอกเป็น ช่องว่างมั้ย
                            const chkEmpty = itm.subtopic.find(
                                (e) => e.page == null || e.page == '' || e.page == undefined,
                            )
                            if (chkEmpty) {
                                isEmptyPage = true
                            }
                        }
                    }
                })
            })
        }

        return isEmptyPage
    }
    const validateRequiredUploadFile = (uploadFile: Array<{ uploadFileObj: any }>, skipValidate: boolean = false) => {
        let isValid = true
        if (!skipValidate) {
            uploadFile?.every(({ uploadFileObj: file }) => {
                if (file?.isRequired && file?.fileList?.length === 0) {
                    //เป็นหัวข้อที่มีการ required แต่ว่าไม่ upload เอกสาร
                    isValid = false
                    return false //break
                }
                return true //continue
            })

            if (!isValid) {
                setConfigDialog({
                    title: translate.get('ALERT.TITLE.NOTIFICATION'),
                    content: translate.get2Element('ALERT.CONTENT.PLEASE_UPLOAD_REQUIRED_TOPIC', [
                        '<label style="color: red;">*</label>',
                    ]) as any,
                    type: 'alert-message',
                })
                dialogTwoRef.current?.openDialog()
            }
        }
        return isValid
    }
    const handleSave = async () => {
        if (validateRequiredUploadFile(submitValueRef.current.uploadFile)) {
            if (parameterForSaveRef.current?.documentInfo?.length === 0) {
                setConfigDialog({
                    title: translate.get('ALERT.TITLE.NOTIFICATION'),
                    content: translate.get('ALERT.CONTENT.UPLOAD_AT_LEAST_1_FILE'),
                    type: 'alert-message',
                })
            } else {
                const isRequirePDF = checkRequirePDF(parameterForSaveRef.current?.documentInfo)
                const allAdditionalDocTopicsHavePdf = checkAllAdditionalDocTopicsHavePdf(
                    parameterForSaveRef.current?.documentAdditionalInfo,
                )
                const isEmptyPage = checkSubtopic(parameterForSaveRef.current?.documentInfo)
                if (isRequirePDF || !allAdditionalDocTopicsHavePdf) {
                    setConfigDialog({
                        title: translate.get('ALERT.TITLE.NOTIFICATION'),
                        content: translate.get('ALERT.CONTENT.UPLOAD_PDF_AT_LEAST_1_FILE'),
                        type: 'alert-message',
                    })
                } else if (isEmptyPage) {
                    setConfigDialog({
                        title: translate.get('ALERT.TITLE.NOTIFICATION'),
                        content: translate.get('ALERT.CONTENT.PLEASE_COMPLETE_PAGE'),
                        type: 'alert-message',
                    })
                } else {
                    setConfigDialog({
                        title: translate.get('ALERT.TITLE.NOTIFICATION'),
                        content: translate.get('ALERT.CONTENT.NEED_TO_SAVE'),
                        type: 'alert-confirm',
                        onClickConfirm: handleClickConfirmSave,
                    })
                }
            }

            dialogTwoRef.current?.openDialog()
        }
    }

    const handleSaveDraft = async () => {
        handleClickConfirmSave()
    }
    const handleClickCancel = (dirty: boolean) => {
        if (dirty) {
            setConfigDialog({
                title: translate.get('ALERT.TITLE.WARNING'),
                content: translate.get('ALERT.CONTENT.NEED_TO_CANCEL'),
                type: 'alert-confirm',

                onClickConfirm: () => {
                    history.push(RoutePath.manageProject)
                },
            })
            dialogTwoRef.current?.openDialog()
        } else {
            history.push(RoutePath.manageProject)
        }
    }

    const onRefDialogTwo = (func: Record<string, Function>) => {
        //ห้าม set State หรือเรียก Action ในนี้
        dialogTwoRef.current = func
    }

    const handleClickConfirmSave = async () => {
        loadingOpen()
        // let res
        // if (isApproveWithComment) {
        //     const parameterEditAfterReview = _.pick(parameterForSaveRef.current, [
        //         'documentInfo',
        //         'isDraft',
        //         'projectID',
        //         'submittedID',
        //     ])
        //     res = await callWebService.projectApproveWithComment(parameterEditAfterReview)
        // } else {
        //Flow ยื่นโครงการใหม่ + Flow แก้ไขหลังพิจารณา
        const res = await callWebService.terminateProject(parameterForSaveRef.current)
        // }
        loadingClose()

        setConfigDialog({}) //clear function dialog
        dialogTwoRef.current?.closeDialog()
        if (formMode === 'EDIT') {
            if (onSaveComplete) onSaveComplete(res?.status, parameterForSaveRef.current?.isDraft as boolean)
        } else if (formMode === 'CREATE') {
            setConfigDialog({
                title: translate.get('ALERT.TITLE.NOTIFICATION'),
                content: translate.get('ALERT.CONTENT.SAVE_SUCCESS'),
                type: 'alert-message',
                onAfterClose: handleAfterCloseCreateSuccess,
            })
            appFolderAndTabAction.resetTabDirty()
            dialogTwoRef.current?.openDialog()
            projectIDRef.current = res.result?.projectInfo?.projectID
            submittedIDRef.current = res.result?.projectInfo?.submittedID
            irbRef.current = res.result?.projectInfo?.irb
        }
    }

    const handleAfterCloseCreateSuccess = () => {
        setConfigDialog({}) //clear function dialog
        //เล่นใน mode create save เสร็จจะต้องไปเข้าหน้า Edit/View
        const encryptedProjectID = encryptionAES(`${projectIDRef.current}`)
        const encryptedSubmittedID = encryptionAES(`${submittedIDRef.current}`)
        const path = generatePath(RoutePath.manageProjectEdit, {
            projectID: encryptedProjectID,
            submittedID: encryptedSubmittedID,
        })
        history.push({
            pathname: path, // editMode
        })
    }

    const handleChangeFaculty = (irb?: string) => {
        if (irb) {
            const submittedTypeID =
                manageProjectStore.projectData?.submitTypeInfo?.value ?? constSubmittedType.firstSubmitConsideration
            getDocumentTopicLut(parseInt(irb), submittedTypeID)
        }
    }

    const handleChangeResearcherType = (val?: string) => {
        if (val) {
            filterTopicUpload(val)
            researcherTypeRef.current = val
        }
    }

    const filterTopicUpload = (val: string) => {
        let docTopic: ResultDocumentTopicLut[] = []
        if (documentTopic && documentTopicRef.current) {
            let isDocTopic = documentTopicRef.current
            if (val === '1') {
                topicForLecturer.forEach((element) => {
                    docTopic = isDocTopic?.filter((item) => {
                        return item.id !== element.id
                    })
                })
            } else {
                topicForStudent.forEach((element) => {
                    docTopic = isDocTopic?.filter((item) => {
                        return item.id !== element.id
                    })
                    isDocTopic = docTopic
                })
            }
            if (docTopic.length > 1) {
                docTopic = docTopic?.map((itm, index: number) => {
                    return { ...itm, no: index + 1 }
                })
                manageProjectAction.setDocumentTopic(docTopic)
            }
        }
    }

    const getDocumentTopicLut = async (irb: number, submittType: number) => {
        let submittedTypeID = projectSubmittedTypeID ? projectSubmittedTypeID : submittType

        if (irb) {
            const res = await callLookup.callDocumentTopicLut(irb, submittedTypeID)
            if (res.status === 1) {
                manageProjectAction.setDocumentTopic(res.result)
                documentTopicRef.current = res.result
            } else {
                manageProjectAction.setDocumentTopic([])
                documentTopicRef.current = []
            }

            if (researcherTypeRef.current) {
                filterTopicUpload(researcherTypeRef.current)
            }
        }
    }

    const createInitialUploadFile = () => {
        let documentInfo = manageProjectStore.projectData?.documentInfo
        let latestDocument = manageProjectStore.projectData?.latestDocument
        // const uploadFileinit: Array<UploadFileObjType> = documentTopicList?.map((itm: any, idx: number) => {
        let uploadFileInit = documentTopic?.map((itm: any, idx: number) => {
            return {
                uploadFileObj: {
                    fileList: [],
                    subTopicPageList: [],
                    documentTopicID: itm.id,
                    isDisplay: itm.isDisplay,
                    isRequired: itm.isRequired,
                },
            }
        }) as Array<UploadFileObjType>

        uploadFileInit?.forEach((itm: UploadFileObjType) => {
            documentInfo?.forEach((docInfo: any) => {
                if (docInfo.topicID === itm.uploadFileObj.documentTopicID) {
                    let fileList = docInfo?.fileInfo?.map((file: any) => ({
                        documentTopicID: docInfo.topicID,
                        fileToken: file.fileToken, //fileToken
                        filename: file.filename,
                        fileID: file.fileID, //fileToken
                        path: file.path,
                        replaceFileID: file.replaceFileID,
                    }))
                    itm.uploadFileObj.fileList = fileList
                    const subtopic = docInfo.subtopic?.map((sub: any) => ({
                        page: sub.page,
                        documentTopicID: docInfo.topicID,
                        subtopicID: sub.subtopicID,
                    }))
                    itm.uploadFileObj.subTopicPageList = subtopic
                }
            })
        })

        //Section Replace File
        if (latestDocument && latestDocument?.length > 0) {
            uploadFileInit?.forEach((initFileItm) => {
                //loop structure init file

                latestDocument?.forEach((docItm) => {
                    //loop document topic
                    const docFileInfo = docItm.fileInfo

                    docFileInfo?.forEach((replaceFileItm: any) => {
                        //loop file in document
                        const lstReplaceFileGroup: Array<any> = replaceFileItm.latestFileList
                        const replaceFile = lstReplaceFileGroup.filter((file) => file.no !== null)?.[0] //ไฟล์เก่าที่ถูกแทนที่
                        const replaceFileBy = lstReplaceFileGroup.filter((file) => file.no === null)?.[0] //ไฟล์ใหม่ที่นำมาแทนที่
                        if (replaceFile && replaceFileBy) {
                            if (docItm.topicID === initFileItm.uploadFileObj.documentTopicID) {
                                initFileItm.uploadFileObj.fileList = [
                                    ...initFileItm.uploadFileObj.fileList,
                                    {
                                        documentTopicID: docItm.topicID,
                                        fileToken: replaceFileBy.fileToken, //fileToken
                                        filename: replaceFileBy.filename,
                                        fileID: replaceFileBy.fileID, //fileToken
                                        path: replaceFileBy.path,
                                        replaceFileID: replaceFileBy.replaceFileID,
                                    } as any,
                                ]

                                const subtopic = docItm.subtopic?.map((sub: any) => ({
                                    page: sub.page,
                                    documentTopicID: docItm.topicID,
                                    subtopicID: sub.subtopicID,
                                }))
                                //ห้าม overwrite ทับค่า subTopicPageList เดิมถ้า latestDocument ไม่มีข้อมูล subtopic
                                if (subtopic && subtopic.length > 0) {
                                    initFileItm.uploadFileObj.subTopicPageList = subtopic
                                }
                            }
                        }
                    })
                })
            })
        }
        // //**** Initial File Edit ****//
        // if (latestDocument && latestDocument.length > 0) {
        //     uploadFileInit?.forEach((itm: UploadFileObjType) => {
        //         latestDocument?.forEach((latestDocInfo: any) => {
        //             let latestFile = []
        //             let previousFile = []
        //             if (latestDocInfo?.fileInfo[0]) {
        //                 latestFile = latestDocInfo.fileInfo[0].latestFileList.filter((itm: any) => itm.no === null)
        //                 previousFile =
        //                     latestDocInfo.fileInfo[0].latestFileList[
        //                         latestDocInfo.fileInfo[0].latestFileList.length - 2
        //                     ]
        //             }
        //             if (latestFile.length > 0) {
        //                 if (latestDocInfo.topicID === itm.uploadFileObj.documentTopicID) {
        //                     let fileList = [
        //                         {
        //                             documentTopicID: latestDocInfo.topicID,
        //                             fileToken: latestFile[0].fileToken, //fileToken
        //                             filename: latestFile[0].filename,
        //                             fileID: latestFile[0].fileToken, //fileToken
        //                             path: latestFile[0].path,
        //                             replaceFileID: previousFile?.fileID,
        //                         },
        //                     ]
        //                     itm.uploadFileObj.fileList = fileList
        //                     itm.uploadFileObj.subTopicPageList = []
        //                 }
        //             }
        //         })
        //     })
        // }

        //Filter การซ่อนแสดงหัวข้อเอกสาร ถ้าฝั่งสำนักงานให้ซ่อนหัวข้อเอกสาร แต่ว่าหัวข้อนั้นมีไฟล์อยู่ให้ทำการแสดงหัวข้อนั้นออกมา
        if (uploadFileInit?.length > 0) {
            uploadFileInit = uploadFileInit.filter((itm: any) => {
                return itm.uploadFileObj.isDisplay || itm.uploadFileObj.fileList.length !== 0
            })
        }
        setInitialUploadFile(uploadFileInit)
    }

    const handleClickClose = () => {
        history.push(RoutePath.manageProject)
    }
    const handleDirtyChange = (props: any) => {
        const paramsDirty = {
            tabDirty: isViewMode ? false : props.dirty,
            callbackDirty: callbackDirtyProcess,
        }
        appFolderAndTabAction.setDirty(paramsDirty)
    }
    const callbackDirtyProcess = (tabIndex: number, newTabSelected: any) => {
        isDraftRef.current = true

        if (valuesForm) {
            const values = { ...valuesForm.current } as TerminateProjectType.MyRequestFormType
            const parameterForSave: REQServiceTypes.CreateProjectRequestType = getParameterForSave(values)
            parameterForSaveRef.current = parameterForSave
            newTabSelectedRef.current = newTabSelected
            tabSelectedIndexRef.current = tabIndex
            handleSaveDraft()
        }
    }

    const checkUseUploadEdit = () => {
        let isUseUploadEdit = false

        switch (manageProjectStore.projectData?.submitTypeInfo?.value) {
            case constSubmittedType.editAfterReview_terminateProject:
                isUseUploadEdit = true
                break
            default:
                isUseUploadEdit = false
        }

        return isUseUploadEdit
    }

    const handleDeleteProject = () => {
        setConfigDialog({
            title: translate.get('ALERT.TITLE.WARNING'),
            content: translate.get('ALERT.CONTENT.NEED_TO_DELETE'),
            type: 'alert-confirm',

            onClickConfirm: async () => {
                if (manageProjectStore?.projectData?.projectID) {
                    const res = await callWebService.deleteProject(manageProjectStore?.projectData?.projectID)
                    setConfigDialog({}) //clear function dialog
                    history.push('/manage-project')
                }
            },
        })
        dialogTwoRef.current?.openDialog()
    }

    const chkDisplayBTNDeleteProject: boolean =
        (initialData?.projectSubmitType &&
            checkPermission.chkDisplayBTNDeleteProject(parseInt(initialData?.projectSubmitType.value)) &&
            initialData?.isDraft &&
            manageProjectStore.projectData?.verifyDocument == null) ||
        false
    return {
        isDraftData: chkDisplayBTNDeleteProject,
        initialUploadFile,
        configDialog,
        onRefDialogTwo,
        selectedIrb,
        configLoading,
        valuesForm,
        projectData: manageProjectStore.projectData,
        handleDirtyChange,
        onClickSubmit: handleClickSubmit,
        onClickCancel: handleClickCancel,
        onClickClose: handleClickClose,
        onClickDeleteProject: handleDeleteProject,
        handleChangeFaculty: handleChangeFaculty,
        onChangeResearcherType: handleChangeResearcherType,
        checkUseUploadEdit,
    }
}

export default useRequestForm
